/*
 * @Author: XCL
 * @Date: 2016-01-15
 * @LastEditTime: 2021-11-30 18:56:50
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\editingCenter\newspaper\alertViews\signedZP\signedZP.js
 * @Description: 
 */
'use strict';
angular.module('editNewspapaerSignedZPModule', [])
    .controller('editNewspapersignedZPCtrl', ['$scope', '$state', '$filter', '$modalInstance', 'trsHttpService', 'item', 'trsspliceString', 'modalDialog', 'options', 'editIsLock',
        function ($scope, $state, $filter, $modalInstance, trsHttpService, item, trsspliceString, modalDialog, options, editIsLock) {
            initStatus();

            /**
         * [initStatus description]
         *
         * @return  {[type]}  [return description]
         */
            function initStatus() {
                $scope.items = item;
                $scope.isRequeted = false;
            }
            $scope.cancel = function () {
                $modalInstance.close(false);
            };

            /**
         * [reponseFilter description]过滤返回的reports
         * @param  {[obj]} elm [description]各个返回的report
         * @return {[null]}     [description]
         */
            $scope.reportsFilter = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.ISSUCCESS == 'false';
                }
            };

            /**
         * [successReportsFilter description]过滤返回的签发成功项
         * @param  {[obj]} elm [description]返回的report
         * @return {[type]}     [description]
         */
            $scope.successReportsFilter = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.ISSUCCESS == 'true';
                }
            };

            /**
             * [confirm description] 关闭弹窗
             * @return  {[type]}  [return description]
             */
            $scope.confirm = function () {
                if ($state.params.papermetadataid) { // 表示编辑页需要先解锁，因为保存后需要加一遍锁
                    editIsLock.normalLock($state.params.papermetadataid).then(() => {
                        doSign();
                    });
                } else {
                    doSign();
                }
            };

            /**
             * [doSign description] 执行签发
             * @return  {[type]}  [return description]
             */
            function doSign() {
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: options && options.methodname ? options.methodname : 'doQianFa',
                    SrcDocIds: trsspliceString.spliceString(item,
                        'METADATAID', ','),
                    IsPaiChong: true,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', true).then(function (data) {
                    modalDialog.multiReportsAlert(data, '');
                    $modalInstance.close('success');
                }, function (data) {
                    if (data.status === '-1') {
                        modalDialog.alertType('签发失败', data.message, 'error', false);
                        return;
                    }
                    var failTemp = $filter('pick')(angular.copy(data.REPORTS), $scope.reportsFilter);
                    var successTemp = $filter('pick')(angular.copy(data.REPORTS), $scope.successReportsFilter);
                    var result = {
                        reports: failTemp,
                        params: params,
                        successReports: successTemp,
                        errorData: data
                    };
                    $modalInstance.close(result);
                });
            }
        }]);
